import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  createFilterOptions, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState,} from "react";
import {useNavigate, useParams,} from "react-router-dom";
import Select from "react-select";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import FormPageHeader from "../utilities/FormPageHeader";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {checkNumber, checkShortKey, checkSpecialChar, checkString, emailValidation,} from "../utilities/FormValidation";
import AgGridTable from "../utilities/AgGridTable";
import * as Flags from "country-flag-icons/react/3x2";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import customStyles from "app/shared-components/SelectCustomStyle";
import {toast} from "react-toastify";
import IconComponent from "app/shared-components/IconComponent";
import UserFormPopup from "../users/UserFormPopup";
import {
  canIAMManagePartner,
  getIAMPartnerIds,
  IAM_SHOWROOM_ACCESS_MESSAGE,
  isIAMOnlyUser,
} from "../utilities/iamTerritoryUtils";
import history from "@history";
import RequiredLabel from "../utilities/RequiredLabel";

const routingOptions = [
  { value: "ABdelivery", label: "AB Delivery" },
  { value: "CommercialInvoice", label: "Commercial Invoice" },
  { value: "SOA", label: "SOA" },
  { value: "LogisticDocuments", label: "Logistic Documents" },
  { value: "SalesInvoice", label: "Sales Invoice" },
  { value: "MISREPORT", label: "MIS REPORT" },
  { value: "PIDelivery", label: "PI Delivery" },
  { value: "ForwarederInfoPending", label: "Forwarder Info Pending" },
  // {
  //   value: "InitialOrderacknowledgement",
  //   label: "Initial Order acknowledgement",
  // },
  // { value: "Loadingweekinfo", label: "Loading week info" },
  // { value: "OngoingOrderinfo", label: "On going Order info" },
  // { value: "Orderrelease", label: "Order release" },
  // { value: "ContainerBooking", label: "Container Booking" },
];
const getErrorMessage = (error) =>
  error?.response?.data?.errorMessage || error?.message;

const hasBlankRoutingField = (obj) =>
  !obj.emailRouting || !obj.from || !obj.to || !obj.cc;

const isRoutingIncomplete = (obj) =>
  hasBlankRoutingField(obj) || !obj.to?.length || !obj.cc?.length;

const scrollToField = (key) =>
  document
    .getElementById(`field-${key}`)
    ?.scrollIntoView({ behavior: "smooth", block: "center" });

const ShowroomForm = () => {
  const [partner, setPartner] = useState();
  const [subAccountNr, setSubAccountNr] = useState();
  const [shortKey, setShortKey] = useState();
  const [showroomManagerId, setShowroomManagerId] = useState();
  const [showroomName, setShowroomName] = useState();
  const [showroomSize, setShowroomSize] = useState();
  const [showroomSizeOption, setShowroomSizeOption] = useState([
    { label: "0 M2 to 100 M2", value: "0 M2 to 100 M2" },
    { label: "101 M2 to 300 M2", value: "101 M2 to 300 M2" },
    { label: "301 M2 & Above", value: "301 M2 & Above" },
  ]);
  const [countryName, setCountryName] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [zipcode, setZipCode] = useState();
  const [address1, setAddress1] = useState();
  const [address2, setAddress2] = useState();
  const [city, setCity] = useState();
  const [addcountryName, setAddcountryName] = useState();
  const [currency, setCurrency] = useState("EURO");
  const [partnerId, setPartnerId] = useState();
  const [defaultContactNumber, setDefaultContactNumber] = useState();
  const [defaultContactName, setDefaultContactName] = useState();
  const [region, setRegion] = useState();
  const [email, setEmail] = useState();
  const [active, setActive] = useState(false);
  const [showInBudget, setShowInBudget] = useState(false);
  const [showInMisReport, setShowInMisReport] = useState(false);
  const [budgetOrderCategoryIds, setBudgetOrderCategoryIds] = useState([]);
  const [altaddress, setAltAddress] = useState(null);
  const [emailRouting, setEmailRouting] = useState([]);
  const [savedEmailRouting,setSavedEmailRouting]=useState([])
  const [poBox, setPoBox] = useState();
  const [rowData, setRowData] = useState([]);
  const shortKeyRef = useRef();
  const zipCodeRef = useRef();
  const showroomNameRef = useRef();
  const showroomSizeRef = useRef();
  const childRef = useRef();
  const [status, setStatus] = useState();
  const [editData, setEditData] = useState();
  const [updateUserModel,setUpdateUserModel]=useState(false)
  const [popupTabValue, setPopupTabValue] = useState(0);
  useEffect(() => {
    if (!updateUserModel) setPopupTabValue(0);
  }, [updateUserModel]);
  const [selectedRows, setSelectedRows] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [selectedEmailRows, setSelectedEmailRows] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [addCount, setAddCount] = useState(0);
  const [emailCount, setEmailCount] = useState(0);
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(Boolean(params.id));
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const [leaveTx, setLeaveTx] = useState(null);
  const [confirmRoutingDelete, setConfirmRoutingDelete] = useState(false);
  const allowLeave = useRef(false);
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showrooms}`;
  const userURL = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}?size=1000`;
  const [allUserList, setAllUserList] = useState([]);
  const [error, setError] = useState();
  const [countryOptions, setCountryOptions] = useState();
  const [cityOptions, setCityOptions] = useState();
  const [companyOptions, setCompanyOptions] = useState();
  const [saveEmailRouting, setSaveEmailRouting] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [hideDelete, setHideDelete] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const filter = createFilterOptions();
  const [regionOptions, setRegionOptions] = useState();
  const [partnerOptions, setPartnerOptions] = useState();
  const [orderTypeOptions, setOrderTypeOptions] = useState();
  const [validError, setValidError] = useState({});
  const [checksubmit, setCheckSubmit] = useState(false);
  const [user, setUser] = useState();
  const [emailRoutingOption,setEmailRoutingOption]=useState(routingOptions)
  const queryParam = new URLSearchParams(window.location.search);
  const EmailRoutingDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState("");
    const userData = async () => {
      try {
        const list = await OAuthService.getList(
          userUrl + `?sort=firstName,asc&size=1000`
        );
        const users = list.data?._embedded?.users.map((data, key) => {
          data.name = data.firstName + " " + data.lastName;
          return data;
        });
        const roleUsers = users.filter(
          (user) =>
            user.roles.includes("ROLE_PARTNER_ADMIN") ||
            user.roles.includes("ROLE_SHWRMMGR") ||
            user.roles.includes("ROLE_PARTNER")
        );
        setUser(
          roleUsers.map((item) => ({
            value: item.email,
            label: `${item.firstName} ${item.lastName}`,
          }))
        );
      } catch (error) {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    };
    const emailRouteChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      setValue(value);
      // setOpenCom(false);
      setEmailRouting(prev => ([...prev].map(item => {
          if (item.id === data.id) {
            return {
              ...item,
              emailRouting: value?.label
            }
          } else {
            return {...item}
          }
        })))
      setSavedEmailRouting(pre=>([...pre]?.map(item=>{
          if (item.id === data.id) {
            return {
              ...data
            }
          } else {
            return {...item}
          }
        })))
      setSelectedEmailRows([])
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.label;
        },
      };
    });
    useEffect(() => {
      if(data){
        setValue(routingOptions?.filter((item)=>item?.label?.toUpperCase() === data?.emailRouting?.toUpperCase())[0])
      }
    }, [data]);
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth

    return (
      <div className="w-full" style={{width:selectWidth}}>
        <Select
          name="emailRouting"
          value={value}
          ref={refEmailRouting}
          onChange={emailRouteChange}
          className="select"
          classNamePrefix="select"
          options={props?.options}
          styles={customStyles()}
        />
      </div>
    );
  });
  const EmailFromDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState(null);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.label;
        },
      };
    });
    useEffect(() => {
      if(data){
        const oldValue=props?.userData?.filter((item)=>item?.label === data?.from)[0]
        if(oldValue){
          setValue(oldValue)
        }else{
          if(data.from){
            setValue({ label: data?.from, value: data?.from })
          }
        }
      }
    }, [data]);
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth

    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Autocomplete
            freeSolo
            name={"from"}
            ref={refEmailRouting}
            selectOnFocus
            disableClearable={true}
            options={props?.userData}
            value={value}
            onChange={(e,newValue)=>{
              if(newValue) {
                setValue(newValue)
                setEmailRouting(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      from:newValue?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }
            }}
            onInputChange={(e,newValue)=>{
              if(newValue){
                setValue({
                  label:newValue,
                  value: newValue,
                });
              }else {
                if(newValue === "") {
                setValue({label:newValue,value:newValue})
                }
              }
            }}
            onBlur={(e,newValue)=>{
              if(!e?.target?.value) return
              setValue({
                label: e?.target?.value,
                value: e?.target?.value,
              });
              setEmailRouting(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      from:e?.target?.value
                    }
                  } else {
                    return {...item}
                  }
                })))
              setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data
                    }
                  } else {
                    return {...item}
                  }
                })))
              setSelectedEmailRows([])
            }}
            size={"small"}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                    sx={{padding:"0 !important"}}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
      </div>
    );
  });
  const EmailToDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState([]);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.map((data) => data?.label);
        },
      };
    });
    useEffect(() => {
      if(data.to){
        const list=data?.to
        let newData=[]
        list?.forEach(item=>{
          if(item){
            newData.push({label:item,value:item})
          }
        })
        setValue(newData)
      }
    }, [data]);
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth

    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Autocomplete
            freeSolo
            name={"to"}
            multiple={true}
            ref={refEmailRouting}
            selectOnFocus
            disableClearable
            options={props?.userData}
            value={value}
            filterSelectedOptions
            onChange={(e,newValue)=>{
              if(newValue){
                setValue(newValue)
                setEmailRouting(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      to:[...newValue?.map(item=>item?.label)],
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }
            }}
            onBlur={(e,newValue)=>{
              const values=e?.target?.value
              if(values){
                setValue((pre)=>([...pre,{ label:values, value:values }]))
                setEmailRouting(prev => ([...prev]?.map(item => {
                    if (item.id === data.id) {
                      return {
                        ...item,
                        to:[...item.to,e?.target?.value]
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                    if (item.id === data.id) {
                      return {
                        ...data
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSelectedEmailRows([])
              }else{
                setEmailRouting(prev => ([...prev]?.map(item => {
                    if (item.id === data.id) {
                      return {
                        ...item,
                        to:[...value?.map(item=>item?.label)],
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                    if (item.id === data.id) {
                      return {
                        ...data
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSelectedEmailRows([])
              }
            }}
            filterOptions={(options, params) => {
              const  filterOptions= filter(options, params);

              const { inputValue } = params;
              const filtered=filterOptions?.filter((item=>!value.some(fItem=>fItem.label === item.label)))

              if (options.length > 0) {
                const isExisting = options?.some(
                    (option) => inputValue === option.label
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push({label:`${inputValue}`,inputValue});
                }
              }

              return filtered;
            }}
            size={"small"}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                    sx={{padding:"0 !important"}}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
      </div>
    );
  });
  const EmailCcDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState([]);

    const handleCountryChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      setValue(value);
    };

    useEffect(() => {
      if(data.cc){
        const list=data?.cc
        let newData=[]
        list?.forEach(item=>{
          if(item){
            newData.push({label:item,value:item})
          }
        })
        setValue(newData)
      }
    }, [data]);
    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.map((data) => data.label);
        },
      };
    });
    const selectWidth=document.querySelector('.ag-cell-popup-editing')?.offsetWidth

    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Autocomplete
            freeSolo
            name={"cc"}
            multiple={true}
            ref={refEmailRouting}
            selectOnFocus
            disableClearable
            options={props?.userData}
            value={value}
            filterSelectedOptions
            onChange={(e,newValue)=>{
              if(newValue){
                setValue(newValue)
                setEmailRouting(prev => ([...prev]?.map(item => {
                  if (item.id === data.id) {
                    return {
                      ...item,
                      cc:[...newValue?.map(item=>item?.label)]
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                  if (item.id === data.id) {
                    return {
                      ...data
                    }
                  } else {
                    return {...item}
                  }
                })))
                setSelectedEmailRows([])
              }
            }}
            onBlur={(e,newValue)=>{
              const values=e?.target?.value
              if(values){
                setValue((pre)=>([...pre,{label:values,value:values}]))
                setEmailRouting(prev => ([...prev]?.map(item => {
                    if (item.id === data.id) {
                      return {
                        ...item,
                        cc:[...item.cc,e?.target?.value]
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                    if (item.id === data.id) {
                      return {
                        ...data
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSelectedEmailRows([])
              }else{
                setEmailRouting(prev => ([...prev]?.map(item => {
                    if (item.id === data.id) {
                      return {
                        ...item,
                        cc:[...value?.map(item=>item?.label)]
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSavedEmailRouting(pre=>([...pre]?.map(item=>{
                    if (item.id === data.id) {
                      return {
                        ...data
                      }
                    } else {
                      return {...item}
                    }
                  })))
                setSelectedEmailRows([])
              }
            }}
            filterOptions={(options, params) => {
              const  filterOptions= filter(options, params);

              const { inputValue } = params;
              const filtered=filterOptions.filter((item=>!value?.some(fItem=>fItem.label === item.label)))

              if (options.length > 0) {
                const isExisting = options.some(
                    (option) => inputValue === option.label
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push({label:`${inputValue}`,inputValue});
                }
              }

              return filtered;
            }}
            size={"small"}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                    sx={{padding:"0 !important"}}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
      </div>
    );
  });

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "emailRouting",
      headerName: "Email Routings",
      headerClass: "required-header",
      cellEditorPopup: true,
      cellEditor: EmailRoutingDropdown,
      cellEditorParams:{
        options:emailRoutingOption
      }
    },
    {
      field: "from",
      cellEditorPopup: true,
      cellEditor: EmailFromDropdown,
      headerName: "From",
      headerClass: "required-header",
      cellEditorParams:{
        userData:allUserList
      }
    },
    {
      field: "to",
      cellEditorPopup: true,
      cellEditor: EmailToDropdown,
      headerName: "To",
      headerClass: "required-header",
      cellEditorParams:{
        userData:allUserList
      }
    },
    {
      field: "cc",
      headerName: "CC",
      headerClass: "required-header",
      cellEditorPopup: true,
      cellEditor: EmailCcDropdown,
      cellEditorParams:{
        userData:allUserList
      }
    },
  ]);
const [userTabColumnDefs,setUserTabColumnDefs]=useState([
  { field: 'name', enableRowGroup: true },
  { field: 'country', enableRowGroup: true },
  { field: 'companyName', enableRowGroup: true, headerName: 'Partner' },
  { field: 'showroomName', enableRowGroup: true, headerName: 'Showroom' },
  { field: 'roles', enableRowGroup: true },
  { field: 'active', cellRenderer: IconComponent },
])
  const checkedStatus = (st) => {
    setStatus(st)
  }
  useEffect(() => {
    checkedStatus()
  },[])
  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  }
  const onRowDoubleClicked = (params) => {
   setUpdateUserModel(true)
  }
  const handleCloseUpdateUserModel= () =>{
    setUpdateUserModel(false)
  }
  const onEmailSelectionChanged = (params) => {
    setSelectedEmailRows(params.api.getSelectedRows());
  };

  const getManagerMailError = (value) => {
    if (
      typeof value !== "string" ||
      !value ||
      value === editData?.showroomManagerId
    ) {
      return "";
    }
    const invalid = value
      .split(";")
      .map((item) => item.trim())
      .filter(Boolean)
      .find((item) => emailValidation(item));
    return invalid ? `${invalid} is not a valid email` : "";
  };

  const submitShowroom = async () => {
    setCheckSubmit(true);
    setError(undefined);
    const phoneNumbers =
      typeof phoneNumber === "string" ? phoneNumber.split(",") : phoneNumber;
    const altaddressArray =
      altaddress &&
      altaddress.map((data, index) => {
        return {
          tag: data.tag,
          address1: data.address1,
          address2: data.address2,
          poBox: data.poBox,
          city: data.city,
          country: data.country,
        };
      });

    const shortKeyError =
      checkShortKey(shortKey) || (await checkUniqueShortkey(shortKey));
    const zipcodeError = checkNumber(zipcode);
    const managerMailError = getManagerMailError(showroomManagerId);
    const hasUnsavedBlankRouting = emailRouting?.some(
      (row) =>
        hasBlankRoutingField(row) &&
        !savedEmailRouting?.some((saved) => saved.id === row.id)
    );
    setValidError((prev) => ({
      ...prev,
      shortKey: shortKeyError,
      zipcode: zipcodeError,
      showroomManagerId: managerMailError,
    }));
    let model = {
      customerNumber: params.id ? params.id : subAccountNr,
      id: params.id ? params.id : subAccountNr,
      name: showroomName,
      shortKey: shortKey,
      showroomManagerId: showroomManagerId,
      countryName: countryName,
      phoneNumbers: phoneNumbers,
      zipCode: zipcode,
      defaultAddress: address1 && {
        tag: "default",
        address1: address1,
        address2: address2,
        poBox: poBox,
        city: city,
        country: addcountryName,
      },
      alternateAddress: altaddressArray && altaddressArray,
      parentCompanyNumber: partnerId,
      parentCompanyName: partner,
      defailtContactNumber: defaultContactNumber,
      defaultContactName: defaultContactName,
      region: region,
      emailId: email,
      active: active,
      showInBudget: showInBudget,
      budgetOrderCategoryIds: budgetOrderCategoryIds,
      showInMisReport: showInMisReport,
      showroomSize: showroomSize,
      emailRoutings: emailRouting,
    };
    if (zipcodeError) {
      zipCodeRef.current?.focus();
    }
    if (shortKeyError) {
      shortKeyRef.current?.focus();
    }
    const missingField = [
      ["partner", partner],
      ["showroomName", showroomName],
      ["showroomSize", showroomSize],
      ["shortKey", shortKey],
      ["budgetCategories", budgetOrderCategoryIds?.length > 0],
      ["address1", address1],
      ["city", city],
    ].find(([, value]) => !value);
    if (missingField) {
      setError("Please fill all the required fields.");
      setTabValue(0);
      setTimeout(() => scrollToField(missingField[0]), 50);
      return;
    }
    const invalidField = [
      ["shortKey", shortKeyError],
      ["zipcode", zipcodeError],
      ["showroomManagerId", managerMailError],
    ].find(([, message]) => message);
    if (invalidField) {
      setError("Please correct the highlighted fields.");
      setTabValue(0);
      setTimeout(() => scrollToField(invalidField[0]), 50);
      return;
    }
    if (!(await canIAMManagePartner(partnerId))) {
      setError(IAM_SHOWROOM_ACCESS_MESSAGE);
      return;
    }
    if (hasUnsavedBlankRouting) {
      setError(
        "Please complete or remove the incomplete email routings in the Emails tab."
      );
      return;
    }
    if (!addcountryName) {
      setError(
        "Country is missing for the address. Please select the City again."
      );
      return;
    }
    try {
      if (params.id) {
        await OAuthService.updateData(url, params.id, model);
        setSuccessMsg("Data Updated Successfully");
        setSnackState(true);
        await editShowroom();
      } else {
        await OAuthService.addData(url, model);
        setSuccessMsg("Data saved Successfully");
        setSnackState(true);
        allowLeave.current = true;
        await new Promise((resolve) => setTimeout(resolve, 800));
        navigate("/showrooms");
      }
    } catch (error) {
      setError(getErrorMessage(error));
    }
  };

  const runSaving = async (task) => {
    if (savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    try {
      return await task();
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const handleSubmit = () => runSaving(submitShowroom);

  useEffect(() => {
      const selectedRoutes=emailRouting?.map((item)=>item?.emailRouting)
      const check= routingOptions.filter(
          (item) =>
              !selectedRoutes?.some((ftItem) => ftItem === item.label)
      )
      setEmailRoutingOption(check)
  }, [selectedEmailRows]);
  /**
   * Tab Change
   */
  const getUserList = async () => {
    const userData = await OAuthService.getList(userURL);
    setAllUserList(
        userData?.data?._embedded?.users?.map((option) => {
          return { value: option.email, label: option.email };
        })
    );
  };

  useEffect(()=>{
      if(emailRoutingOption){
        const clone=[...columnDefs]
        clone?.map((item)=>{
          if(item?.field === "emailRouting"){
            return item.cellEditorParams.options=emailRoutingOption
          }
        })
        setColumnDefs(clone)
      }
    if(allUserList){
      const clone=[...columnDefs]
      clone?.map((item)=>{
        if(item.field === "from" || item.field === "to"  || item.field === "cc"  ){
          return item.cellEditorParams.userData=allUserList
        }
      })
      setColumnDefs(clone)
    }
  },[emailRoutingOption,allUserList])

  const handleTabChange = (event, value) => {
    setTabValue(value);
    setSelectedEmailRows([])
  };

  const editShowroom = async () => {
    try {
      const result = await OAuthService.getEditData(url, params.id);
      const showroom = result.data;
      if (!(await canIAMManagePartner(showroom?.parentCompanyNumber))) {
        toast.error(IAM_SHOWROOM_ACCESS_MESSAGE);
        navigate("/showrooms");
        return;
      }
      setEmailRouting(
        (showroom?.emailRoutings || []).map((items, index) => {
          return { ...items, id: index + 1 };
        })
      );
      setSavedEmailRouting(
        (showroom?.emailRoutings || []).map((items, index) => {
          return { ...items, id: index + 1 };
        })
      )
      setShowroomName(showroom?.name?.toUpperCase());
      setPartner(showroom?.parentCompanyName);
      setCountryName(showroom?.countryName);
      setSubAccountNr(params.id);
      setShortKey(showroom?.shortKey);
      setShowroomManagerId(showroom?.showroomManagerId);
      setPhoneNumber(showroom?.phoneNumbers);
      setZipCode(showroom?.zipCode);
      setBudgetOrderCategoryIds(showroom?.budgetOrderCategoryIds);
      setShowInBudget(showroom?.showInBudget);
      setShowInMisReport(showroom?.showInMisReport);
      setActive(showroom?.active);
      setEmail(showroom?.emailId);
      setRegion(showroom?.region);
      setDefaultContactName(showroom?.defaultContactName);
      setDefaultContactNumber(showroom?.defailtContactNumber);
      setPartnerId(showroom?.parentCompanyNumber);
      setAddress1(showroom?.defaultAddress?.address1);
      setAddress2(showroom?.defaultAddress?.address2);
      setPoBox(showroom?.defaultAddress?.poBox);
      setAddcountryName(showroom?.defaultAddress?.country);
      setCity(showroom?.defaultAddress?.city);
      if (showroom?.alternateAddress !== null) {
        setAltAddress(showroom?.alternateAddress);
        setAddCount(addCount + 1);
      }
      setShowroomSize(showroom?.showroomSize);
      setEditData(showroom);
    } catch (error) {
      setError(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params.id) {
      editShowroom();
      setHideDelete(false);
    } else {
      const getNextSeqOfNum = async () => {
        if (!params.id) {
          try {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/nextSeqNumOfShowroom`;
            const nextSeqNumOfCompany = await OAuthService.getList(url);
            setSubAccountNr(nextSeqNumOfCompany.data);
          } catch (error) {
            console.log(error);
          }
        }
      };

      getNextSeqOfNum();
    }
    getUserList().catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    if (queryParam.get("tab") !== null) {
      setTabValue(parseInt(queryParam.get("tab"), 10));
    }
  }, [queryParam.get("tab")]);

  const checkUniqueShortkey = async (key) => {
    if (!key || (params.id && key === editData?.shortKey)) {
      return "";
    }
    try {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showroom}/showroomByShortKey?shortKey=${key}`;
      const result = await OAuthService.getList(url);
      return result.data ? "This short key is already exist" : "";
    } catch (error) {
      return "";
    }
  };

  useEffect(() => {
    if (queryParam.get("customerId")) {
      const companies = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}?size=1000`;

        const list = await OAuthService.getList(url);

        const listResult = list?.data?._embedded?.companies.map((value) => {
          return {
            label: value.name,
            value: value.name,
            id: value._links.company.href.split("/").pop(),
          };
        });

        setCompanyOptions(listResult);
        if (listResult) {
          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

          const result = await OAuthService.getEditData(
            url,
            queryParam.get("customerId")
          );
          const company = result.data;

          setPartner(company?.name);
          setPartnerId(queryParam.get("customerId"));
        }
      };
      companies().catch((error) => setError(getErrorMessage(error)));
    }
  }, [queryParam.get("customerId")]);

  const deleteShowroom = async () => {
    if (!(await canIAMManagePartner(partnerId))) {
      setError(IAM_SHOWROOM_ACCESS_MESSAGE);
      return;
    }
    try {
      if (params.id) {
        await OAuthService.deleteData(url, params.id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
        allowLeave.current = true;
      }
    } catch (error) {
      setError(getErrorMessage(error));
      return;
    }
    await new Promise((resolve) => setTimeout(resolve, 800));
    navigate("/showrooms");
  };

  const handleDelete = () => runSaving(deleteShowroom);

  const handleCountryChange = (data) => {
    setCountryName(data.value);
  };

  const handlePartnerChange = async (data) => {
    setPartner(data.value);
    setPartnerId(data.id);
    const partnerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
    try {
      const result = await OAuthService.getEditData(partnerUrl, data.id);
      const customer = result.data;
      params.id && setBudgetOrderCategoryIds(customer?.budgetOrderCategoryIds);
      setCity(customer?.defaultAddress?.city);
      setAddcountryName(customer?.countryName);
    } catch (error) {
      setError(getErrorMessage(error));
    }
  };
  const handleRegionChange = (region,action) => {
    setRegion(action.action === "clear"?"":region.value);
  };
  const handleAddCountryChange = (data) => {
    setAddcountryName(data.value);
  };
  const handleAddCityChange = async (data) => {
    setCity(data.value);
    try {
      const countryChange = await OAuthService.getList(
        `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}/${data.id}/country`
      );
      setAddcountryName(countryChange?.data?.name);
    } catch (error) {
      setError(getErrorMessage(error));
    }
  };
  const handleActiveChange = (e) => {
    setActive(e.target.checked);
  };
  const handleBudgetChange = (e) => {
    setShowInBudget(e.target.checked);
  };
  const handleReportChange = (e) => {
    setShowInMisReport(e.target.checked);
  };

  useEffect(() => {
    const country = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
      const countries = await OAuthService.getList(url);

      const result = countries?.data?._embedded.countries.map((value) => {
        const Flag = Flags[value.isoCode];
        return {
          label: value.name,
          value: value.name,
          code: value.isoCode,
          icon: value.isoCode && (
            <Flag width={18} style={{ marginInline: "5px" }} />
          ),
        };
      });
      setCountryOptions(result);
    };
    const region = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.regions}`;
      const region = await OAuthService.getList(url);
      const result = region?.data?._embedded?.regions.map((value) => {
        const data = value?._links?.region?.href.split("/").pop();
        return { label: data, value: data };
      });

      setRegionOptions(result);
    };
    const orderType = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}`;
      const orderCategories = await OAuthService.getList(url);
      const data = orderCategories?.data?._embedded?.orderCategories;
      const result = orderCategories?.data?._embedded?.orderCategories.map(
        (value) => {
          return {
            label: value.name + " " + value.displayName,
            value: value.name,
          };
        }
      );
      setOrderTypeOptions(result);
      !params.id && handleBudgetCatChange(data);
    };
    const partnerOpt = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}?size=1000`;
      const partners = await OAuthService.getList(url);

      let result = partners?.data?._embedded?.companies.map((value) => {
        return {
          label: value.id + " - " + value.name,
          value: value.name,
          id: value?._links.company.href.split("/").pop(),
        };
      });
      if (isIAMOnlyUser()) {
        const partnerIds = await getIAMPartnerIds();
        result = result.filter((option) =>
          partnerIds.includes(String(option.id))
        );
      }
      setPartnerOptions(result);
    };
    const cityOpt = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}?size=1000`;
      const cities = await OAuthService.getList(url);

      const result = cities?.data?._embedded?.cities.map((value) => {
        return {
          label: value.cityName,
          value: value.cityName,
          id: value._links.city.href.split("/").pop(),
        };
      });
      setCityOptions(result);
    };
    [cityOpt, partnerOpt, orderType, region, country].forEach((load) =>
      load().catch((error) => setError(getErrorMessage(error)))
    );
  }, []);
  const handleBudgetCatChange = (data) => {
    const cats = data.map((row) => {
      return row.value || row.name;
    });
    setBudgetOrderCategoryIds(cats);
  };

  const users = async () => {
    if (params.id) {
      try {
        const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByShowroomId?showroomId=${params.id}`;
        const list = await OAuthService.getList(url);
        const userList = (list.data?._embedded?.users || []).map((data) => {
          data.name = data.firstName + " " + data.lastName;
          return data;
        });
        setRowData(userList);
      } catch (error) {
        setError(getErrorMessage(error));
      }
    }
  };
  const saveUpdatedUserData = () =>{
    const childelement = childRef.current;
    const submitData = childelement?.handleSubmit();
    submitData.then((val) => {
      if(val){
        setUpdateUserModel(false);
        setSuccessMsg(val)
        setSnackState(true)
        users();
      }
    })
  }
  const onGridReady = useCallback((params) => {
    if(params.api){
      users();
      setGridApi(params.api);
    }
  }, []);

  const updateAltAddress = (index, changes) => {
    setAltAddress((prev) =>
      prev.map((item, i) => (i === index ? { ...item, ...changes } : item))
    );
  };

  const handleAltAddress = async (index, e, name, action) => {
    if (name === "city") {
      if (!e || action?.action === "clear") {
        updateAltAddress(index, { city: "", country: "" });
        return;
      }
      updateAltAddress(index, { city: e.value });
      try {
        const countryChange = await OAuthService.getList(
          `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}/${e.id}/country`
        );
        updateAltAddress(index, { country: countryChange?.data?.name });
      } catch (error) {
        setError(getErrorMessage(error));
      }
      return;
    }
    updateAltAddress(index, { [e.target.name || name]: e.target.value });
  };

  //   const handleEmailRouting = (index, e, name) => {
  //     const routings = [...emailRouting];

  //     routings[index][e.target?.name || name] =
  //       e.target?.value || e.target?.innerHTML || e.value;
  //     setEmailRouting(routings);
  //   };
  //   const handleEditEmailRouting = (index, e, name) => {
  //     const routings = saveEmailRouting.filter((data, key) => {
  //       if (key === index) {
  //         data[name || e?.target?.name] = e?.target?.value || e.value;
  //       }
  //       return data;
  //     });
  //     setSaveEmailRouting(routings);
  //   };
  //   const editEmailRouting = (index, value) => {
  //     const saved = saveEmailRouting.map((data, key) => {
  //       if (key === index) {
  //         data.edit = value;
  //       }
  //       return data;
  //     });
  //     setSaveEmailRouting(saved);
  //   };
  //   const addEmailRouting = async (data, index, type) => {
  //     let updatedData;
  //     if (type === "edit") {
  //       updatedData = saveEmailRouting.map((data, key) => {
  //         if (key === index) {
  //           data.edit = false;
  //         }
  //         return data;
  //       });
  //       setSaveEmailRouting(updatedData);
  //       updatedData = updatedData.map((data, key) => {
  //         delete data.edit;
  //         delete data?.error;
  //         return data;
  //       });
  //     } else if (type === "add") {
  //       updatedData = saveEmailRouting
  //         ? [...saveEmailRouting, { ...data }]
  //         : [{ ...data }];
  //       setSaveEmailRouting(
  //         saveEmailRouting
  //           ? [...saveEmailRouting, { ...data, edit: false }]
  //           : [{ ...data, edit: false }]
  //       );
  //       updatedData = updatedData.map((data, key) => {
  //         delete data?.edit;
  //         delete data?.error;
  //         return data;
  //       });
  //       const routings = emailRouting.filter((data, key) => {
  //         if (key !== index) {
  //           return data;
  //         }
  //       });
  //       setEmailRouting(routings);
  //     }
  //     let model = {
  //       emailRouting: updatedData,
  //     };
  //     try {
  //       if (data) {
  //         // await OAuthService.updateData(url, params.id, model);
  //       }
  //     } catch (error) {
  //       setError(error.message);
  //     }
  //   };
  //   const deleteEmailRouting = async (index, type) => {
  //     if (type == "add") {
  //       const routing = emailRouting.filter((data, key) => {
  //         if (key !== index) {
  //           return data;
  //         }
  //       });
  //       setEmailRouting(routing);
  //     } else if (type == "edit") {
  //       const saveRouting = saveEmailRouting.filter((data, key) => {
  //         if (key !== index) {
  //           return data;
  //         }
  //       });
  //       setSaveEmailRouting(saveRouting);
  //       saveRouting = saveRouting.map((data, key) => {
  //         delete data.edit;
  //         delete data.error;
  //         return data;
  //       });
  //       let model = {
  //         emailRouting: saveRouting,
  //       };
  //       try {
  //         // await OAuthService.updateData(url, params.id, model);
  //       } catch (error) {
  //         setError(error.message);
  //       }
  //     }
  //   };

  const deleteAlternateAddress = (index) => {
    const altadds = altaddress.filter((data, key) => {
      if (key !== index) {
        return data;
      }
    });
    setAltAddress(altadds);
  };

  const handleCancel = () => {
    navigate("/showrooms");
  };

  useEffect(() => {
    if (editData) {
      if (
        partner !== editData.parentCompanyName ||
        showroomName !== editData.name?.toUpperCase() ||
        showroomSize !== editData.showroomSize ||
        shortKey !== editData.shortKey ||
        (showroomManagerId || "") !== (editData.showroomManagerId || "") ||
        JSON.stringify(budgetOrderCategoryIds) !==
          JSON.stringify(editData.budgetOrderCategoryIds) ||
        address1 !== editData.defaultAddress?.address1 ||
        city !== editData.defaultAddress?.city ||
        region !== editData.region ||
        zipcode !== editData.zipCode ||
        address2 !== editData.defaultAddress?.address2 ||
        poBox !== editData.defaultAddress?.poBox ||
        JSON.stringify(altaddress) !==
          JSON.stringify(editData.alternateAddress) ||
        active !== editData.active ||
        showInBudget !== editData.showInBudget ||
        showInMisReport !== editData.showInMisReport
      ) {
        setSaveDisable(false);
      } else {
        setSaveDisable(true);
      }
    } else {
      setSaveDisable(Boolean(params.id));
    }
  }, [
    partner,
    showroomName,
    showroomSize,
    shortKey,
    showroomManagerId,
    budgetOrderCategoryIds,
    address1,
    city,
    region,
    zipcode,
    address2,
    poBox,
    altaddress,
    active,
    showInBudget,
    showInMisReport,
  ]);

  const deleteSelectedRouting = async () => {
    setConfirmRoutingDelete(false);
    const routing = emailRouting.filter(
      (item) => !selectedEmailRows.some((ftItem) => ftItem.id === item.id)
    );
    setEmailRouting(routing);
    if (routing.some(hasBlankRoutingField)) {
      setSelectedEmailRows([]);
      return;
    }
    try {
      await OAuthService.updateData(url, params.id, {
        emailRoutings: routing,
      });
      setSavedEmailRouting(routing.map((item) => ({ ...item })));
      setSelectedEmailRows([]);
      toast.success("Routing deleted successfully");
    } catch (error) {
      setError(getErrorMessage(error));
    }
  };

  const handleDeleteRouting = () => runSaving(deleteSelectedRouting);

  const matchTwoArray=(a,b)=>{
    return a?.length === b?.length &&
        a?.every(
            (e1)=>
                b?.some(
                    (e2)=>
                        e1?.emailRouting === e2?.emailRouting &&
                        e1?.subject === e2?.subject &&
                        e1?.from === e2?.from &&
                        e1?.to === e2?.to &&
                        e1?.cc === e2?.cc
                )
        )
  }
  const isDirty = params.id
    ? !saveDisable || !matchTwoArray(emailRouting, savedEmailRouting)
    : Boolean(
        showroomName ||
          shortKey ||
          showroomSize ||
          address1 ||
          address2 ||
          zipcode ||
          showroomManagerId ||
          region
      );

  useEffect(() => {
    if (!isDirty) return undefined;
    const unblock = history.block((tx) => {
      if (allowLeave.current) {
        unblock();
        tx.retry();
        return;
      }
      setLeaveTx({ unblock, retry: tx.retry });
    });
    return unblock;
  }, [isDirty]);

  return (
    <div className="w-full h-full overflow-scroll">
      <Backdrop
        open={loading || saving}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <FormPageHeader
        componentName="Showroom"
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        successMsg={successMsg}
        snackState={snackState}
        breadCrumbSeperator=">"
        currentPage={params.id ? "Update Showroom ("+showroomName+")" : "Add Showroom"}
        parentBreadcrumbData={[
          { pageName: "Showroom List", pageLink: "/showrooms" },
        ]}
        error={error}
        handleCancel={handleCancel}
        hideDelete={hideDelete}
        saveDisable={saveDisable}
        saveDisabledHint="No changes to save"
      >
       <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
        >
          <Tab 
            label="General" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
          {params.id && (
            <Tab 
              label="User" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
            />
          )}
          {params.id && (
            <Tab 
              label="Emails" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
            />
          )}
        </Tabs>
      </FormPageHeader>
      <div
        className="p-16 sm:p-24"
        style={{ height: "Calc(100% - 140px - 76px)" }}
      >
        <FormControl
          // ref={formRef}
          className="flex flex-col justify-top h-full"
        >
          <div className={tabValue !== 0 ? "hidden" : ""}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box
                  className="mb-20 mt-20"
                  sx={{ p: 2, border: "1px dashed grey" }}
                >
                  <Stack className="mb-16">
                    <RequiredLabel id="field-partner">Select Partner</RequiredLabel>
                    <Select
                      name="partner"
                      value={
                        partnerOptions &&
                        partnerOptions.filter(
                          (obj) => partnerId && String(obj.id) === String(partnerId)
                        )
                      }
                      onChange={handlePartnerChange}
                      className="basic-multi-select "
                      isDisabled={queryParam.get("customerId") ? true : false}
                      classNamePrefix="select"
                      options={partnerOptions}
                      styles={customStyles(
                        ((checksubmit && !partner) || validError.partner) &&
                          "#f44336"
                      )}
                    />
                    <Typography className="text-[#f44336] text-sm ml-14">
                      {checksubmit && !partner
                        ? "This field is required"
                        : validError.partner}
                    </Typography>
                  </Stack>
                  <Stack>
                    <label>Sub Account Nr</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      name="subAccountNr"
                      value={subAccountNr}
                      disabled
                      onChange={(e) => setSubAccountNr(e.target.value)}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: subAccountNr ? true : false,
                      }}
                    />
                  </Stack>
                  <Stack>
                    <RequiredLabel id="field-showroomName">Showroom Name</RequiredLabel>
                    <TextField
                      className="mb-16 uppercase"
                      type="text"
                      error={
                        (checksubmit && !showroomName) ||
                        validError.showroomName
                          ? true
                          : false
                      }
                      name="showroomName"
                      value={showroomName}
                      inputRef={showroomNameRef}
                      onChange={(e) => {
                        setShowroomName(e.target.value.toUpperCase());
                        // setValidError({
                        //   ...validError,
                        //   showroomName:
                        //     // checkString(e.target.value) ||
                        //     checkSpecialChar(e.target.value),
                        // });
                      }}
                      helperText={
                        checksubmit && !showroomName
                          ? "This field is required"
                          : validError.showroomName
                      }
                      variant="outlined"
                      InputLabelProps={{
                        shrink: showroomName ? true : false,
                      }}
                    />
                  </Stack>
                  <Stack>
                    <RequiredLabel id="field-showroomSize">Showroom Size</RequiredLabel>
                    <Select
                      className="mb-16"
                      value={
                        showroomSize &&
                        showroomSizeOption.length > 0 &&
                        showroomSizeOption.filter(
                          (size) => size.value === showroomSize
                        )
                      }
                      name="showroomSize"
                      ref={showroomSizeRef}
                      options={showroomSizeOption}
                      onChange={(e) => {
                        setShowroomSize(e.value);
                      }}
                      styles={customStyles(checksubmit && !showroomSize && "#f44336")}
                    ></Select>
                    <Typography className="text-[#f44336] text-sm ml-14">
                      {checksubmit && !showroomSize
                        ? "This field is required"
                        : ""}
                    </Typography>
                    {/* <TextField
                                            className="mb-16"
                                            type="text"
                                            error={(checksubmit && !showroomSize) || validError.showroomSize ? true : false}
                                            name="showroomSize"
                                            inputRef={showroomSizeRef}
                                            value={showroomSize}
                                            
                                            helperText={(checksubmit && !showroomSize) ? "This field is required" : validError.showroomSize}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: showroomSize ? true : false,
                                            }}
                                        /> */}
                  </Stack>
                  <Stack>
                    <label>Select Region</label>
                    <Select
                      name="region"
                      value={
                        regionOptions &&
                        regionOptions.filter(
                          (obj) => region && region.toLowerCase() === obj.value.toLowerCase()
                        )
                      }
                      onChange={handleRegionChange}
                      className="select mb-16"
                      classNamePrefix="select"
                      options={regionOptions}
                      styles={customStyles()}
                      isClearable
                    />
                  </Stack>
                  <Stack>
                    <label id="field-showroomManagerId">Showroom Manager Mail Ids (; Separated)</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      name="showroomManagerId"
                      value={showroomManagerId}
                      error={validError.showroomManagerId ? true : false}
                      helperText={validError.showroomManagerId}
                      onChange={(e) => {
                        setShowroomManagerId(e.target.value);
                        setValidError((prev) => ({
                          ...prev,
                          showroomManagerId: getManagerMailError(e.target.value),
                        }));
                      }}
                      variant="outlined"
                    />
                  </Stack>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  className="mb-20 mt-20"
                  sx={{ p: 2, border: "1px dashed grey" }}
                >
                  <Stack>
                    <RequiredLabel id="field-shortKey">Short Key</RequiredLabel>
                    <TextField
                      className="mb-16"
                      type="text"
                      name="shortKey"
                      inputRef={shortKeyRef}
                      error={
                        (checksubmit && !shortKey) || validError?.shortKey
                          ? true
                          : false
                      }
                      value={shortKey}
                      required
                      onChange={(e) => {
                        setShortKey(e.target.value);
                        setValidError({
                          ...validError,
                          shortKey: checkShortKey(e.target.value),
                        });
                      }}
                      helperText={
                        checksubmit && !shortKey
                          ? "This field is required"
                          : validError?.shortKey
                      }
                      onBlur={async (e) => {
                        const message = await checkUniqueShortkey(
                          e.target.value
                        );
                        if (message) {
                          setValidError((prev) => ({
                            ...prev,
                            shortKey: message,
                          }));
                        }
                      }}
                      variant="outlined"
                      inputProps={{
                        maxLength: 2,
                      }}
                    />
                  </Stack>
                  <Stack className="mb-16">
                    <RequiredLabel id="field-budgetCategories">Budget Categories</RequiredLabel>
                    <Select
                      name="budgetCat"
                      value={
                        orderTypeOptions &&
                        budgetOrderCategoryIds &&
                        orderTypeOptions.filter((obj) =>
                          budgetOrderCategoryIds.includes(obj.value)
                        )
                      }
                      onChange={handleBudgetCatChange}
                      isMulti
                      className="select"
                      classNamePrefix="select"
                      options={orderTypeOptions}
                      styles={customStyles(
                        checksubmit && !budgetOrderCategoryIds?.length && "#f44336"
                      )}
                    />
                    <Typography className="text-[#f44336] text-sm ml-14">
                      {checksubmit && !budgetOrderCategoryIds?.length
                        ? "This field is required"
                        : validError.budgetOrderCategoryIds}
                    </Typography>
                  </Stack>
                  <Stack>
                    <label>Currency</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      name="currency"
                      value={currency}
                      aria-readonly
                      disabled
                      onChange={(e) => setCurrency(e.target.value)}
                      variant="outlined"
                    />
                  </Stack>
                  <Stack>
                    <label id="field-zipcode">ZIP Code</label>
                    <TextField
                      className="mb-16"
                      inputRef={zipCodeRef}
                      type="text"
                      name="zipcode"
                      value={zipcode}
                      required
                      onChange={(e) => {
                        setZipCode(e.target.value);
                        setValidError({
                          ...validError,
                          zipcode: checkNumber(e.target.value),
                        });
                      }}
                      helperText={validError.zipcode}
                      variant="outlined"
                    />
                  </Stack>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={active}
                          onChange={handleActiveChange}
                        />
                      }
                      label="Active"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={showInBudget}
                          onChange={handleBudgetChange}
                        />
                      }
                      label="Show In Budget"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={showInMisReport}
                          onChange={handleReportChange}
                        />
                      }
                      label="Show In Mis Report"
                    />
                  </FormGroup>
                </Box>
              </Grid>
            </Grid>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: "1px dashed grey" }}
            >
              <Stack>
                <Typography className="mb-16">Default Address</Typography>
                <RequiredLabel id="field-address1">Address 1</RequiredLabel>
                <TextField
                  className="mb-16"
                  type="text"
                  error={
                    (checksubmit && !address1) || validError.address1
                      ? true
                      : false
                  }
                  name="address1"
                  value={address1}
                  required
                  onChange={(e) => setAddress1(e.target.value)}
                  helperText={
                    checksubmit && !address1
                      ? "This field is required"
                      : validError.address1
                  }
                  variant="outlined"
                  InputLabelProps={{
                    shrink: address1 ? true : false,
                  }}
                  autoFocus={
                    (checksubmit && !address1) || validError.address1
                      ? true
                      : false
                  }
                />
                <label>Address 2</label>
                <TextField
                  className="mb-16"
                  type="text"
                  error={validError.address2 ? true : false}
                  name="address2"
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                  helperText={validError.address2}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: address2 ? true : false,
                  }}
                />
                <Stack className="mb-16">
                  <RequiredLabel id="field-city">Select City</RequiredLabel>
                  <Select
                    name="city"
                    // {partnerOptions && partnerOptions.filter(obj => partner && partner.includes(obj.value))
                    value={
                      cityOptions &&
                      city &&
                      cityOptions.filter(
                        (obj) => city.toLowerCase() === obj.value.toLowerCase()
                      )
                    }
                    onChange={handleAddCityChange}
                    className="select"
                    classNamePrefix="select"
                    options={cityOptions}
                    styles={customStyles(checksubmit && !city && "#f44336")}
                    autoFocus={checksubmit && !city ? true : false}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !city
                      ? "This field is required"
                      : validError.city}
                  </Typography>
                </Stack>
                <label>PO Box</label>
                <TextField
                  className="mb-16"
                  type="text"
                  name="poBox"
                  error={validError.poBox ? true : false}
                  value={poBox}
                  required
                  onChange={(e) => setPoBox(e.target.value)}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: poBox ? true : false,
                  }}
                  autoFocus={validError.poBox ? true : false}
                />
                {/* <Stack className="mb-16">
                                    <Select name="addcountryName"
                                        value={(countryOptions && addcountryName) && countryOptions.filter(obj => addcountryName.includes(obj.value))}
                                        onChange={handleAddCountryChange}
                                        className="select"
                                        classNamePrefix="select"
                                        options={countryOptions}
                                        getOptionLabel={e => (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {e.icon}
                                                <span style={{ marginLeft: 5 }}>{e.label}</span>
                                            </div>
                                        )}
                                        styles={customStyles(((checksubmit && !addcountryName) || validError.addcountryName) && "#f44336")}
                                    />
                                    <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !addcountryName) ? "This field is required" : validError.addcountryName}</Typography>
                                </Stack> */}
              </Stack>
            </Box>
            {((addCount > 0 && altaddress) ||
              (params.id && altaddress !== null)) &&
              altaddress.map((element, index) => {
                return (
                  <Box
                    key={index}
                    className="mb-20 mt-20"
                    sx={{ p: 2, border: "1px dashed grey" }}
                  >
                    <Stack>
                      <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={(e) => {
                            deleteAlternateAddress(index);
                          }}
                        >
                          <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                        </Button>
                      </div>
                      <Typography className="mb-16">Alternate Address</Typography>
                      <label>Address 1</label>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="address1"
                        value={element.address1}
                        required
                        onChange={(e) => handleAltAddress(index, e)}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: element.address1 ? true : false,
                        }}
                      />
                      <label>Address 2</label>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="address2"
                        value={element.address2}
                        required
                        onChange={(e) => handleAltAddress(index, e)}
                        variant="outlined"
                      />
                      <label>Select City</label>
                      <Select
                        name="city"
                        value={
                          cityOptions &&
                          element.city &&
                          cityOptions.filter((obj) =>
                            element.city.toLowerCase() === obj.value.toLowerCase()
                          )
                        }
                        onChange={(e,action) => handleAltAddress(index, e, "city",action)}
                        className="select mb-16"
                        classNamePrefix="select"
                        options={cityOptions}
                        styles={customStyles()}
                        isClearable
                      />
                      <label>PO Box</label>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="poBox"
                        value={element.poBox}
                        required
                        onChange={(e) => handleAltAddress(index, e)}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: element.poBox ? true : false,
                        }}
                      />
                      {/* <Stack>
                                        <Select name="country"
                                            value={(element.country && countryOptions) && countryOptions.filter(obj => element.country.includes(obj.value))}
                                            onChange={(e) => handleAltAddress(index, e, "country")}
                                            className="select mb-16"
                                            classNamePrefix="select"
                                            options={countryOptions}
                                            styles={customStyles()}
                                            getOptionLabel={e => (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    {e.icon}
                                                    <span style={{ marginLeft: 5 }}>{e.label}</span>
                                                </div>
                                            )}
                                        />
                                    </Stack> */}
                    </Stack>
                  </Box>
                );
              })}
            <Stack className="mb-16">
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  setAddCount(addCount + 1);
                  setAltAddress(
                    altaddress
                      ? [
                          ...altaddress,
                          {
                            tag: "",
                            poBox: "",
                            address1: "",
                            address2: "",
                            city: "",
                            country: "",
                          },
                        ]
                      : [
                          {
                            tag: "",
                            poBox: "",
                            address1: "",
                            address2: "",
                            city: "",
                            country: "",
                          },
                        ]
                  );
                }}
              >
                Add Alternate Address
              </Button>
            </Stack>

            {/* <Stack>
                            <label>Country</label>
                            <Select name="countryName"
                                value={countryOptions.filter(obj => countryName && countryName.includes(obj.value))}
                                onChange={handleCountryChange}
                                className="basic-multi-select mb-16"
                                classNamePrefix="select"
                                options={countryOptions}
                            />
                        </Stack> */}
            {/* <Stack>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="phoneNumber"
                                value={phoneNumber}
                                label="Phone Number"
                                required
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                variant="outlined"
                            />
                        </Stack> */}
          </div>
          <div className={tabValue !== 1 ? "hidden" : " h-full"}>
            <Grid
              className="flex flex-row mb-10"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddCircleOutlineIcon />}
                onClick={(e) => navigate("/addUser?showroomId=" + params.id)}
              >
                Add User
              </Button>
            </Grid>
            <Stack className=" h-full">
              <AgGridTable
                rowData={rowData}
                columnDefs={userTabColumnDefs}
                onGridReady={onGridReady}
                saveGridStateName={"showroomsUserList_" + params.id}
                onSelectionChanged={onSelectionChanged}
                onRowDoubleClicked={onRowDoubleClicked}
              />
            </Stack>
          </div>
          <div className={tabValue !== 2 ? "hidden" : "h-full"}>
            <Button
              className="mb-10 float-right"
              variant="contained"
              color="secondary"
              disabled={selectedEmailRows.length > 0 ? false : true}
              onClick={() => setConfirmRoutingDelete(true)}
            >
              <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
            </Button>
            <Button
              className="mb-10 mr-10 float-right"
              variant="contained"
              color="secondary"
              disabled={matchTwoArray(emailRouting,savedEmailRouting) || emailRouting?.some(isRoutingIncomplete)}
              onClick={() => runSaving(async () => {
                let model = {
                  emailRoutings: emailRouting,
                };
                if (emailRouting === undefined || emailRouting?.length === 0) {
                  toast.error("Please add atleast one routing");
                } else {
                  if (
                    emailRouting?.some(isRoutingIncomplete)
                  ) {
                    toast.error("Please fill all the fields");
                  } else {
                    try {
                      await OAuthService.updateData(url, params.id, model);
                      toast.success("Routing saved successfully");
                      setSavedEmailRouting(emailRouting)
                      setSelectedEmailRows([])
                    } catch (error) {
                      setError(getErrorMessage(error));
                    }
                  }
                }
              })}
            >
              <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
            </Button>
            <Button
              className="mb-10 mr-10 float-right"
              variant="contained"
              color="secondary"
              disabled={selectedEmailRows?.length > 0 || emailRouting?.some(isRoutingIncomplete)}
              onClick={() => {
                setEmailCount(emailCount + 1);
                const newRouting = {
                  id:
                    (emailRouting[emailRouting.length - 1]?.id ??
                      emailRouting.length) + 1,
                  emailRouting: "",
                  from: "",
                  to: "",
                  cc: "",
                };
                setEmailRouting([...emailRouting, newRouting]);
                setSelectedEmailRows([newRouting]);
              }}
            >
              Add Routing
            </Button>
            <Stack style={{ height: "500px", width: "100%" }}>
              <AgGridTable
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                gridRef={gridRef}
                rowData={emailRouting}
                // getContextMenuItems={getContextMenuItems}
                onSelectionChanged={onEmailSelectionChanged}
                //   onRowDoubleClicked={onRowDoubleClicked}
              />
            </Stack>
          </div>
          <div className={tabValue !== 3 ? "hidden" : ""}></div>
          <div className={tabValue !== 4 ? "hidden" : ""}></div>
          <div className={tabValue !== 5 ? "hidden" : ""}>
            {/* <FormGroup>
                            <FormControlLabel control={<Checkbox checked={active} onChange={handleActiveChange} />} label="Active" />
                        </FormGroup> */}
            {/* <Stack>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="minOrderValue"
                                label="Min Order Value"
                                value={minOrderValue}
                                required
                                onChange={(e) => setMinOrderValue(e.target.value)}
                                variant="outlined"
                            />
                        </Stack> */}
            {/* <Stack>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="email"
                                label="Email"
                                value={email}
                                required
                                onChange={(e) => setEmail(e.target.value)}
                                variant="outlined"
                            />
                        </Stack> */}
            {/* <Stack>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="parentCompanyNumber"
                                label="Parent Company Number"
                                value={parentCompanyNumber}
                                required
                                onChange={(e) => setParentCompanyNumber(e.target.value)}
                                variant="outlined"
                            />
                        </Stack>
                        <Stack>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="parentCompanyName"
                                label="Parent Company Name"
                                value={parentCompanyName}
                                required
                                onChange={(e) => setParentCompanyName(e.target.value)}
                                variant="outlined"
                            />
                        </Stack> */}
            {/* <Stack>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="defaultContactNumber"
                                label="Default Contact Number"
                                value={defaultContactNumber}
                                required
                                onChange={(e) => setDefaultContactNumber(e.target.value)}
                                variant="outlined"
                            />
                        </Stack> */}
            {/* <Stack>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="defaultContactName"
                                label="Default Contact Name"
                                value={defaultContactName}
                                required
                                onChange={(e) => setDefaultContactName(e.target.value)}
                                variant="outlined"
                            />
                        </Stack> */}
          </div>
        </FormControl>
      </div>
      <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={handleCloseUpdateUserModel}
          open={updateUserModel}
          // {...other}
      >
        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Update User</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={handleCloseUpdateUserModel}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <UserFormPopup id={selectedRows && selectedRows[0]?._links?.user?.href.split('/').pop()} ref={childRef} checkedStatus={checkedStatus} tabValue={popupTabValue} setTabValue={setPopupTabValue}/>
        </DialogContent>
        <DialogActions>
          <Button
              variant="contained"
              color="secondary"
              onClick={saveUpdatedUserData}
              disabled={status}
          >
            <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmRoutingDelete}
        onClose={() => setConfirmRoutingDelete(false)}
      >
        <DialogContent>
          <Typography>
            Are you sure you want to delete the selected routing?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteRouting}>Yes</Button>
          <Button onClick={() => setConfirmRoutingDelete(false)} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={Boolean(leaveTx)} onClose={() => setLeaveTx(null)}>
        <DialogContent>
          <Typography>
            You have unsaved changes. Do you want to leave this page?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              leaveTx.unblock();
              leaveTx.retry();
              setLeaveTx(null);
            }}
          >
            Leave
          </Button>
          <Button onClick={() => setLeaveTx(null)} autoFocus>
            Stay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ShowroomForm;
